import Actions from '../../odata/actions';

const actions = new Actions('saleLead', 'saleLeads');

export default actions;
